import React from 'react'
import PropTypes from 'prop-types'
import { gql, useQuery } from 'urql'
import { joinBy } from 'data/helpers/strings'

const DestinationSelectionPopoverItem = ({ selectRegion = () => { }, viewAll = false, wordpressSlugged = false }) => {
  const [{ data, fetching }] = useQuery({
    query: gql`
      query DestinationSelectionPopoverItemData {
        countries(first: 100) {
          data {
            id
            value
            slug
          }
        }
        regions(first: 100) {
          data {
            id
            value
            slug
            country {
              id
              value
            }
          }
        }
        subRegions(first: 100) {
          data {
            id
            value
            slug
            region {
              id
              value
              country {
                id
                value
              }
            }
          }
        }
      }
    `,
  })

  if (fetching) {
    return null
  }

  let destinations = data.countries.data?.map((country) => {
    return {
      ...country,
      regions: data.regions.data.filter((region) => region.country.id === country.id).map((region) => {
        return {
          ...region,
          subregions: data.subRegions.data.filter((subregion) => subregion.region.id === region.id),
        }
      }),
    }
  }).filter(country => (
    country.regions.length > 0
  ))

  return (
    <>
      <div className="flex flex-col flex-wrap w-full mt-20 xl:flex-row gap-x-50 gap-y-40">
        {destinations?.map(country => (
          <div key={country.id}>
            <button
              type="button"
              className="text-24 font-serif xl:font-sans xl:text-14 text-grey-900 tracking-[-0.09px] leading-30 xl:leading-16 xl:mb-10 xl:mt-15 cursor-pointer hover:underline"
              onClick={() => selectRegion({
                country: {
                  value: country.value,
                  slug: wordpressSlugged ? country.value : country.slug,
                },
                value: country?.value,
              })}
            >
              {country.value}
            </button>

            <div className="items-start mt-15 xl:mt-0 gap-y-60 xl:columns-1">

              <div className={`flex flex-col ${viewAll ? 'gap-y-[17px] xl:gap-y-0' : ''} `}>
                {country.regions?.map(region => (
                  <div className={`grid ${viewAll ? 'xl:mb-15' : ''}`} key={region.id} style={{ gridTemplateRows: '1fr auto', breakInside: 'avoid' }}>
                    <div>
                      <button
                        type="button"
                        className={`cursor-pointer text-14 xl:text-[13px] text-grey-900 leading-28 xl:leading-23 hover:underline ${viewAll ? 'mb-[13px]' : 'xl:text-grey-650'} xl:mb-0`}
                        onClick={() => selectRegion({
                          country: {
                            value: country.value,
                            slug: wordpressSlugged ? country.value : country.slug,
                          },
                          region: {
                            value: region.value,
                            slug: wordpressSlugged ? region.value : region.slug,
                          },
                          value: joinBy([region.value, region.country?.value]),
                        })}
                      >
                        {region.value}
                      </button>
                    </div>
                    {
                      viewAll
                      && <>
                        {region.subregions?.map(subregion => (
                          <div key={subregion.id}>
                            <button
                              type="button"
                              className="cursor-pointer text-14 xl:text-[13px] leading-23 text-grey-650 hover:underline mb-8 xl:mb-0"
                              onClick={() => selectRegion({
                                country: {
                                  value: country.value,
                                  slug: wordpressSlugged ? country.value : country.slug,
                                },
                                region: {
                                  value: region.value,
                                  slug: wordpressSlugged ? region.value : region.slug,
                                },
                                subregion: {
                                  value: subregion.value,
                                  slug: wordpressSlugged ? subregion.value : subregion.slug,
                                },
                                value: joinBy([subregion.value, subregion.region?.value, subregion.region?.country?.value]),
                              })}
                            >
                              {subregion.value}
                            </button>
                          </div>
                        ))}
                      </>
                    }
                  </div>
                ))}
              </div>

            </div>
          </div>
        ))}
      </div>
    </ >
  )
}

DestinationSelectionPopoverItem.propTypes = {
  propagate: PropTypes.bool,
  selectRegion: PropTypes.func,
  viewAll: PropTypes.bool,
  wordpressSlugged: PropTypes.bool,
}

export default DestinationSelectionPopoverItem
